/* bw-wire.js — buy box funcional del clon (la fuente estaba SOLD OUT y dependia de Kaching) */
(function () {
  var VMAP = {
    "1 Kid":  { id: "58432008945928", p: 35.95 },
    "2 Kids": { id: "58432009044232", p: 66.95 },
    "3 Kids": { id: "58432009077000", p: 92.95 },
    "4 Kids": { id: "58432009109768", p: 119.95 },
    "5 Kids": { id: "58432009142536", p: 145.95 }
  };
  var current = "1 Kid";
  function fmt(n) { return "€" + n.toFixed(2).replace(".", ","); }

  function apply(val) {
    if (!VMAP[val]) return;
    current = val;
    var qty = parseInt(val, 10) || 1;          // 1 Kid..5 Kids
    var unitWas = Math.round((VMAP[val].p / qty) * 100) / 100;   // por unidad (descuento por volumen ya en la variante)
    var unitNow = Math.round((unitWas * 100) / 2) / 100;         // 50% OFF FIRST ORDER (redondeo por céntimos, como la fuente)
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (i) { i.value = VMAP[val].id; });
    var d = document.querySelector(".dis-price"); if (d) d.textContent = fmt(unitNow);
    var o = document.querySelector(".org-p-s"); if (o) o.textContent = fmt(unitWas);
    document.querySelectorAll('[name="Select Number of Kids"]').forEach(function (r) {
      r.disabled = false; r.classList.remove("unavailable", "disabled"); r.checked = (r.value === val);
    });
  }

  function enforce() {
    document.querySelectorAll('[name="Select Number of Kids"]').forEach(function (r) {
      if (r.disabled) r.disabled = false;
      r.classList.remove("unavailable", "disabled");
    });
    document.querySelectorAll('.atc-button, .product-form__submit, [id*="bw-03-main"] button[type="submit"]').forEach(function (b) {
      if (b.disabled) { b.disabled = false; b.removeAttribute("disabled"); }
      if (/sold\s*out/i.test(b.textContent)) b.textContent = "ADD TO CART";
    });
  }

  // variante realmente seleccionada AHORA (radio marcado); fallback al form id / current
  function selectedId(form) {
    var checked = (form && form.querySelector('[name="Select Number of Kids"]:checked')) ||
                  document.querySelector('[name="Select Number of Kids"]:checked');
    if (checked && VMAP[checked.value]) return VMAP[checked.value].id;
    var idI = form && form.querySelector('[name="id"]');
    if (idI && idI.value) return idI.value;
    return VMAP[current].id;
  }

  function init() {
    // seleccionar variante al hacer click en su pill/label (fase de captura: gana al JS del tema)
    document.addEventListener("click", function (e) {
      var lab = e.target.closest("label"); if (!lab) return;
      var f = lab.getAttribute("for"); if (!f) return;
      var r = document.getElementById(f); if (!r || r.name !== "Select Number of Kids") return;
      e.preventDefault(); e.stopPropagation(); apply(r.value); enforce();
    }, true);

    // sincronizar TAMBIEN por change nativo del radio: cubre click directo en el radio,
    // teclado, o cualquier via del tema que no pase por el click del <label> de arriba.
    // (el radio NO esta dentro del label: un click en la pill/radio no dispara ese handler)
    // BLOQUEAMOS la propagacion en captura: si el <variant-selects> del tema oye el change,
    // re-renderiza el form fuente (que viene SOLD OUT) -> desengancha nuestro submit y
    // re-deshabilita el boton -> el ATC no anade nada. Al cortarlo, bw-wire manda solo.
    document.addEventListener("change", function (e) {
      var r = e.target; if (!r || r.name !== "Select Number of Kids") return;
      e.stopPropagation(); e.stopImmediatePropagation();
      if (VMAP[r.value]) { apply(r.value); enforce(); }
    }, true);

    // ATC: add.js + abrir drawer. UN solo listener en CAPTURA a nivel documento con
    // stopImmediatePropagation: asi bw-wire es el UNICO que anade. Si dejamos que el
    // <product-form> del tema oiga el submit, anade TAMBIEN (FormData) -> se duplica la
    // cantidad (un click = 2 unidades). Capturamos antes que el handler del tema y lo cortamos.
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var vid = selectedId(form);   // lee la variante marcada AHORA, no la variable current
      var dr = document.querySelector("cart-drawer");
      // pedir a add.js las SECCIONES renderizadas del drawer para poder repintarlo poblado
      // (bloqueamos el add del tema, asi que su refresco del drawer tambien; lo hacemos aqui).
      var sections = (dr && typeof dr.getSectionsToRender === "function")
        ? dr.getSectionsToRender().map(function (s) { return s.id || s.section; })
        : ["cart-drawer", "cart-icon-bubble"];
      fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (res) {
        if (dr) {
          if (dr.classList) dr.classList.remove("is-empty");
          // renderContents (Dawn/Shrine) repinta las line-items Y abre el drawer
          if (typeof dr.renderContents === "function") { try { dr.renderContents(res); return; } catch (x) {} }
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          if (typeof dr.open === "function") { try { dr.open(); return; } catch (x) {} }
        }
        window.location.href = "/cart";
      }).catch(function () { window.location.href = "/cart"; });
    }, true);

    apply("1 Kid"); enforce();
    var t = setInterval(enforce, 400); setTimeout(function () { clearInterval(t); }, 6000);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

/* timeline-activate: la fuente marca .timeline__item con is-active al entrar en viewport (JS de su tema) */
(function () {
  function arm() {
    var items = document.querySelectorAll(".timeline__item");
    if (!items.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) en.target.classList.add("is-active"); });
    }, { threshold: 0.4 });
    items.forEach(function (it) { io.observe(it); });
  }
  if (document.readyState !== "loading") arm();
  else document.addEventListener("DOMContentLoaded", arm);
})();
